<template>

  <div>
    <!--   devices filter-->
    <b-card>
      <b-card-title>{{ $t('devices filters')}}</b-card-title>
      <b-row>
        <b-col md="12">
          <b-form-group :label="$t('Owners')">
            <v-select multiple :close-on-select="false" v-model="selectedOwners"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :getOptionLabel="o => o.name"
                      :options="ownersFilter"
                      :reduce="o => o.id" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group :label="$t('Contracts')">
            <v-select multiple :close-on-select="false" v-model="selectedContracts"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      :getOptionLabel="c => c.name"
                      :options="contractsOptions"
                      :reduce="c => c.id" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!--    report form-->
    <b-card>
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="40" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="submitReport">
        <b-row>
          <b-col md="12">
          <b-form-group :label="`${$t('Devices')}`">
            <v-select multiple :close-on-select="false" v-model="request.devices"
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                      :options="[{ name: $t('all'), device_id: 'all' }, ...devicesOptions]" :reduce="d => d.device_id" />
            <small v-if="errors && ('devices' in errors)" class="text-danger">
              {{ $t(errors['devices'][0]) }}
            </small>
          </b-form-group>
          </b-col>

          <b-col md="12" dir="ltr">
            <b-form-group>
              <h5>{{ $t('Range Datetime')}}</h5>

              <flat-pickr dir="ltr" v-model="rangeDate" class="form-control" :config="{...conf }"/>
              <small v-if="errors && (('from' in errors) || ('to' in errors))" class="text-danger">
                {{ $t(errors['from'][0]) }} {{ $t(errors['to'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <b-col  cols="12">
            <b-button type="submit" variant="primary" class="mr-1">
              {{ $t('SHOW REPORT') }}
            </b-button>


          </b-col>
        </b-row>
      </b-form>
    </b-card>

<!--    <div v-if="result.length > 0">-->

      <b-card v-if="true">
        <b-col cols="12" md="12" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <div class="col-12 mb-1 d-flex justify-content-end">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="export_file('pdf')"
                      type="button" variant="primary" class="mr-1 btn">
              {{ $t('Download PDF') }}
            </b-button>

            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" @click.prevent="export_file('xlsx')"
                      type="button" variant="primary" class="mr-1 btn">
              {{ $t('Download Excel') }}
            </b-button>
          </div>
        </b-col>

        <div v-if="loading" class="loading_page">
          <orbit-spinner :animation-duration="1000" :size="40" :color="'#0e96b1'" />
        </div>

        <b-table class="table table-sm"
                 responsive
                 small
                 :fields="fields.map((i) => ({ key: i.key, label: $t(i.label), sortable: i.sortable }))"
                 :items="result">

          <template #cell(action)="data">
            <a href="#" @click.prevent="openMap(data.item)">{{$t('show path')}}</a>
          </template>

        </b-table>

      </b-card>

  </div>

</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination, BCardTitle, BCardHeader,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia, VBTooltip,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { computed, onMounted, reactive, ref, watch } from '@vue/composition-api'
import axios from '@/libs/axios'
import store from '@/store'
import fields from '@/views/reports/ContainerWashRfidPlan/fields'
import { conf, rangeDate, from, to } from '@/views/reports/SweeperService/_datepicker'
import { createToastInterface } from "vue-toastification"
import '@core/scss/vue/libs/toastification.scss'
import DataTable from '@/views/reports/data-table/DataTable.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    DataTable,
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    BLink,
    BMedia,
    BCardTitle, BCardHeader,
  },
  directives: {
    Ripple,
  },

  setup() {

    const myTable = ref(null)
    const currentPage = ref(1)
    const perPage = ref(25)
    const result = ref([]);
    const errors = ref([]);
    const export_status = ref(false)

    const request = reactive({
      type: 'containerWashRfidPlan',
      devices: [],
      owners: [],
      contracts: [],
      from: from,
      to: to,
      needPagination: false
    })

    const pluginOptions = {
      position: "bottom-right",
      timeout: false,
      closeOnClick: false,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: false,
      draggablePercent: 0.12,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false,
      icon: true,
      rtl: false
    }

    const toast = createToastInterface(pluginOptions)

    const loading = ref(false)
    const devices = ref([])

    const selectedOwners = ref([])
    const selectedContracts = ref([])

    const contractsOptions = computed(() => {
      return contractsFilter.value.filter(i =>
          selectedOwners.value.includes(i.contractor_id))
    })
    const devicesOptions = computed(() => {
      return devices.value.filter(i =>
          (selectedOwners.value.length === 0 && selectedContracts.value.length === 0 )||
          (selectedOwners.value.includes(i.owner_id) ||
          selectedContracts.value.includes(i.contract_id)))
    })

    watch([selectedOwners, selectedContracts], () => {
      request.contracts = selectedContracts.value
      request.owners = selectedOwners.value
    })

    // watch([perPage], () => {
    //   request.perPage = perPage.value
    //   submitReport()
    // })

    const getDevices = _ => {
      axios.get('userGetLinked', {params: {
          user: store.state.auth.userData.id,
          type: 'device',
          cols: 'device_id,name,owner_id,contract_id',
          category: 'CONTAINER_WASHING_TRUCK',
        }}).then(res => devices.value = res.data.data).catch(e => {})
    }

    getDevices()

    const ownersFilter =  ref([])
    const contractsFilter =  ref([])

    axios.get('filters/getFilterBy', { params: {
        type: 'device', category: 'CONTAINER_WASHING_TRUCK', }})
    .then(res => {
      ownersFilter.value = res.data.data.owners
      contractsFilter.value = res.data.data.contracts
    })
    .catch(e => {})

    const handlePageChange = page => {
      request.page = page
      submitReport()
    }

    const handlePerPageChange = page => {
      // console.log(page)
    }

    const submitReport = () => {

      loading.value = true
      errors.value = []

     axios.post('reports', request).then(res => {
       result.value = res.data.data
     }).catch(e => {
       if (e.response.status === 422) {
         errors.value = e.response.data.errors
       }
     }).finally(_ => loading.value = false)

    }

    const export_file = type => {
      toast.info('جاري تحميل الملف ...')
      export_status.value = true
      loading.value = true
      axios.post(
          'export',
          { exporter: type, export: "containerWashRfidPlanReport", ...request },
          {responseType: 'blob'}
      )

      .then(res => {
        const blob = new Blob(
            [res.data],
            { type: res.headers['content-type'], encoding: 'UTF-8' }
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `wash-rfid_plan_report.${type}`;
        link.click();
        URL.revokeObjectURL(url);
      })

      .catch(e => console.log('error export report'))
      .finally(_ => {
        export_status.value = false
        loading.value = false
        toast.clear()
      })

    }

    const sortCompare = (a, b, k) => {
      if (['start_sweep_time', 'end_sweep_time'].includes(k)) {
        return new Date(a[k]) - new Date(b[k]);
      }

      if (['total_sweep_distance', 'total_sweep_duration'].includes(k)) {
         return a[k+'_n'] - b[k+'_n']
      }

      return a[k] < b[k] ? -1 : (a[k] > b[k] ? 1 : 0);
    }

    const openMap = (item) => {
      console.log(item)
      window.open(
          `/device/${item.device_id}/history?from=${item.shift_start}&to=${item.shift_end}`,
          '_blank',
          'height=800,width=1500'
      )
    }

    return {

      myTable,
      currentPage,
      perPage,
      fields,conf, rangeDate,

      result, errors,
      loading, export_status,
      devices,

      // filters
      ownersFilter, contractsFilter,
      selectedOwners, selectedContracts,
      contractsOptions,

      // computed
      devicesOptions,
      request,
      submitReport,
      export_file,
      handlePageChange,
      handlePerPageChange,
      sortCompare,
      openMap
    }
  }
}

</script>

<style scoped lang="scss">
</style>
